import { createFileRoute } from "@tanstack/react-router";

import { adminOrganizationListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminCompaniesPage } from "@/features/admin/organizations-page";
import { adminOrganizationListQueryOptions } from "@/features/admin/queries";

// role を ENTERPRISE 固定にして URL search に乗せる。
// q, sort, order, filter, page, pageSize は applicationListQuerySchema 同様 query で保持。
const companiesSearchSchema = adminOrganizationListQuerySchema.omit({ role: true });

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/organizations/companies")({
  validateSearch: companiesSearchSchema,
  loaderDeps: ({ search }) => ({ ...search, role: "ENTERPRISE" as const }),
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(adminOrganizationListQueryOptions(deps));
  },
  component: AdminCompaniesPage,
});
